<template>
  <section>
    <v-toolbar color="white" class="box-shadow">
      <v-btn color="primary" class="box-shadow" @click="setToday">Today</v-btn>
      <v-spacer/>
      <v-btn text @click="$refs.workingHoursCalendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title class="mx-3">
        {{ $moment(this.focus).format('MMMM YYYY') }}
      </v-toolbar-title>
      <v-btn text @click="$refs.workingHoursCalendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-spacer/>
      <v-toolbar-items style="height: auto">
        <v-select
            v-model="type"
            :items="type_options"
            item-text="label"
            item-value="value"
            menu-props="auto"
            hide-details
            single-line
            outlined
            dense
        ></v-select>
      </v-toolbar-items>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-calendar ref="workingHoursCalendar"
                    :now="today"
                    :type="type"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    @click:more="viewMore"
                    @click:date="viewMore"
                    @click:event="openSelectedItemDialog"
                    @change="loadEvents"
        ></v-calendar>
      </v-card>

      <v-dialog max-width="500px" v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog">
        <v-card v-if="selected_item">
          <v-toolbar dense dark color="primary">
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click="closeSelectedItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ selected_item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ selected_item.short_name }}</v-list-item-subtitle>

            </v-list-item-content>

            <v-list-item-action>
              <v-btn small class="box-shadow" color="success"
                     :to="{name: 'Session', params: {session_id: selected_item.session_id}}">
                Open session
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider/>

          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-timer</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Start {{ $moment(selected_item.start).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
              <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-alarm</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>End {{ $moment(selected_item.end).format('DD MMMM YYYY HH:mm') }}</v-list-item-title>
              <v-list-item-subtitle>UK Time zone</v-list-item-subtitle>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider/>

          <template v-if="profile_type && profile_type !== 'aspiringSolicitor' && selected_item.user">
            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-account</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>Client name</v-list-item-subtitle>
                <v-list-item-title>{{ selected_item.user.full_name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider/>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-account</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>Client nickname</v-list-item-subtitle>
                <v-list-item-title>{{ selected_item.user.nickname }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider/>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-email</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>Client email</v-list-item-subtitle>
                <v-list-item-title>{{ selected_item.user.email }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider/>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-skype</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>Client skype</v-list-item-subtitle>
                <v-list-item-title>{{ selected_item.user.skype }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-if="authUser && selected_item.mock">
            <v-divider/>
            <v-card-text v-if="authUser.id === selected_item.user_id" v-html="selected_item.mock.candidate_instruction"/>
            <v-card-text v-if="authUser.id === selected_item.tutor_id" v-html="selected_item.mock.tutor_instruction"/>
          </template>
        </v-card>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    tutor: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    load_options: null,
    type: 'month',
    type_options: [
      { value: 'month', label: 'Month'},
      { value: 'week', label: 'Week'},
      { value: 'day', label: 'Day'},
    ],
    today: '',
    focus: '',
    event_items: [],
    selected_item: null,
    selected_item_dialog: false,
  }),
  computed: {
    events: function () {
      let items = []

      if(this.authUserStudyGroups) {
        this.authUserStudyGroups.forEach(client_account => {
          if(client_account.status === 'approved' && client_account.studyGroup) {
            items.push({
              name: client_account.studyGroup.name,
              start: client_account.studyGroup.start_at,
              end: client_account.studyGroup.end_at,
              color: 'green',
              type: 'study_group'
            })
          }

          if(client_account.status === 'approved' && client_account.studySubGroup) {
            client_account.studySubGroup.p1_exam_dates.forEach(exam_date => {
              items.push({
                name: client_account.studyGroup.short_name+' OSCE P1 exam',
                start: exam_date,
                end: exam_date,
                color: 'red',
                type: 'exam'
              })
            })
            client_account.studySubGroup.p2_exam_dates.forEach(exam_date => {
              items.push({
                name: client_account.studyGroup.short_name+' OSCE P2 exam',
                start: exam_date,
                end: exam_date,
                color: 'red',
                type: 'exam'
              })
            })
          }
        })
      }

      if(this.event_items && this.event_items.length > 0) {
        let mapped_items = this.event_items.map(item => ({...item, name: item.short_name}))
        items.push(...mapped_items)
      }
      return items
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  methods: {
    loadEvents({start, end}) {
      this.load_options = {start, end}
      this.axios.get(`api/tutors/${this.$route.params.tutor_id}/events`, {params: {date_from: start.date, date_to: end.date}})
          .then(({data}) => { this.event_items = data.data })
    },
    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    viewMore({date}) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      if(event.color) return event.color
      let diff = this.$moment(event.end).diff(this.$currentTime().format())
      return diff > 0 ? 'primary' : 'secondary'
    },
    openSelectedItemDialog({event}) {
      this.selected_item = event
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
  }

}
</script>